import Proptypes from 'prop-types'
import { isPartVisible } from 'utils/displayByDateAndTime'
import FacebookButton from 'components/FacebookButton'
import MultiButtonHalf from 'components/MultiButtonHalf'
import Uploadbutton from 'components/UploadButton'
import LinkButton from 'components/LinkButton'
import Button from 'components/Button'
import ReactHtmlParser from 'react-html-parser'

export const PartButton = ({ part, currentIndex, cardInfos, appInfos, fbsInfos, themeInfos }) => {
  if (!isPartVisible(part)) return null

  const sendMessageToUnity = () => {
    const UnityInAppBrowser = window.UnityInAppBrowser || undefined
    if (UnityInAppBrowser) UnityInAppBrowser.sendMessageFromJS(part.action)
  }

  switch (part.type) {
    case 'Button':
      const text = part.text.replace(/\n/g, '<br />');

      return !!part.url && part.url.length > 0 ? (
        <>
          <LinkButton
            id='action button'
            href={part.url}
            target={part.target}
            outline={part.style ? part.style.alternate : false}
            flat={part?.style?.flat || false}
            msjBrowser={part.msjBrowser}
            beforeText={part.tags && part.tags.beforeText !== '' && part.tags.beforeText}
            afterText={part.tags && part.tags.afterText !== '' && part.tags.afterText}
            themeInfos={themeInfos}
          >
            {ReactHtmlParser(text)}
          </LinkButton>
        </>

      ) : (
        <>
          <Button
            id='action button'
            outline={part.style ? part.style.alternate : false}
            flat={part?.style?.flat || false}
            backBtn={part.return}
            onClick={null}
            beforeText={part.tags && part.tags.beforeText !== '' && part.tags.beforeText}
            afterText={part.tags && part.tags.afterText !== '' && part.tags.afterText}
            themeInfos={themeInfos}
          >
            <span style={{ whiteSpace: 'pre-line' }}>{ReactHtmlParser(text)}</span>
          </Button>
        </>
      )
    case 'ButtonFileUpload':
      const uploadText = part.text ? part.text.replace(/\n/g, '<br />') : "";
      return (
        <Uploadbutton
          id="upload button"
          href={part.url}
          target={part.target}
          outline={part.style ? part.style.alternate : false}
          flat={part?.style?.flat || false}
          msjBrowser={part.msjBrowser}
          beforeText={part.tags && part.tags.beforeText !== '' && part.tags.beforeText}
          afterText={part.tags && part.tags.afterText !== '' && part.tags.afterText}
          part={part}
        >
          <span style={{ whiteSpace: 'pre-line' }}>{ReactHtmlParser(uploadText)}</span>
        </Uploadbutton>
      )
    case 'Button-Half':
      return <MultiButtonHalf allParts={cardInfos.parts} currentIndex={currentIndex} />
    case 'FacebookShareButton':
      return (
        <FacebookButton
          text={part.text}
          tokenId={cardInfos.tokenId}
          cardId={cardInfos.cardId}
          appId={appInfos.id}
          message={part.message}
          hashtag={part.hashtag}
          fbsInfos={fbsInfos}
        />
      )
    case 'BtnUnity':
      return (
        <Button onClick={sendMessageToUnity} data-ga="unity button" id="unity button">
          {part.text}
        </Button>
      )
    default:
      return <div />
  }
}

PartButton.propTypes = {
  part: Proptypes.object,
  currentIndex: Proptypes.any,
  cardInfos: Proptypes.object,
  appInfos: Proptypes.object,
  fbsInfos: Proptypes.any,
  themeInfos: Proptypes.object,
}

export default PartButton
